import type { DomainGuide } from '@/components/guide/guide-types';

import th from './th.json';
import en from './en.json';
import zh from './zh.json';
import vi from './vi.json';
import km from './km.json';
import lo from './lo.json';
import my from './my.json';

/**
 * Help catalog for the `notification` domain — the two tabs of `/notification`.
 *
 * Both are `records-intent`, and it is the same root cause: nothing delivers.
 * `notify.notification_logs` is only ever INSERTed with `status: 'queued'` —
 * there is no UPDATE against it anywhere in the repo, no outbound worker, and
 * svc-notify carries no mail/SMS/LINE dependency. So the Sent and Failed
 * filters cannot return a row, and a template can only ever be copied into a
 * message nobody receives.
 */
export const notificationGuide: DomainGuide = {
  domain: 'notification',
  pages: [
    {
      id: 'notification.logs',
      route: '/notification → Logs',
      permission: 'notify:read',
      status: 'records-intent',
      fields: [
        { key: 'createdAt', kind: 'date' },
        { key: 'channel', kind: 'status' },
        { key: 'toAddress', kind: 'text' },
        { key: 'templateCode', kind: 'text' },
        { key: 'subject', kind: 'text' },
        { key: 'status', kind: 'status' },
        { key: 'audience', kind: 'status' },
        { key: 'body', kind: 'text' },
      ],
      cautionCount: 5,
      warningCount: 2,
    },
    {
      id: 'notification.templates',
      route: '/notification → Templates',
      permission: 'notify:read',
      status: 'records-intent',
      fields: [
        { key: 'code', kind: 'text' },
        { key: 'channel', kind: 'status' },
        { key: 'subject', kind: 'text' },
        { key: 'body', kind: 'text' },
        { key: 'variables', kind: 'text' },
        { key: 'status', kind: 'status' },
      ],
      cautionCount: 6,
      warningCount: 1,
    },
  ],
  copy: { th, en, zh, vi, km, lo, my },
};
